import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import { beforeEach, afterEach } from '@/routers/request'

const routes = [

    { name: 'pg',               path: '/:pg', component: () => import('@/layouts/default.vue') },
    { name: 'pg_1',             path: '/:pg/:get_1', component: () => import('@/layouts/default.vue') },
    { name: 'pg_2',             path: '/:pg/:get_1/:get_2', component: () => import('@/layouts/default.vue') },
    { name: 'pg_3',             path: '/:pg/:get_1/:get_2/:get_3', component: () => import('@/layouts/default.vue') },
    { name: 'pg_4',             path: '/:pg/:get_1/:get_2/:get_3/:get_4', component: () => import('@/layouts/default.vue') },

    // APP
        { name: 'home',         path: '/index.html', component: () => import('@/layouts/default.vue') },
    // APP

    { name: 'home',             path: '/', component: () => import('@/layouts/default.vue') },

]

// HISTORY
    // No app iOS (cordova-ios sem a preferencia `scheme`) o index.html abre por file:// e o
    // caminho da URL e o do bundle (/private/var/.../www/index.html): nenhuma rota casa e o
    // WebKit bloqueia pushState para outro caminho em file://. Por isso, em file:// o roteador
    // usa HASH (#/login/...), que ignora o caminho e so mexe no fragmento. Android
    // (https://localhost) e navegador seguem no history normal.
    const history = window.location.protocol === 'file:'
        ? createWebHashHistory()
        : createWebHistory($_GLOBAL.DIR);
// HISTORY

const router = createRouter({
    history: history,
    routes,
    base: $_GLOBAL.DIR,
    scrollBehavior(to, from, savedPosition) {
        return { top: 0 }
    },
})

router.beforeEach(beforeEach);
router.afterEach(afterEach);

export default router
